import { Notifications } from '@mantine/notifications';
import { useLocation } from 'react-router-dom';
import { clientRoutes } from '@/ApiPaths';

const PRODUCT_EDITOR_PATHS = new Set([clientRoutes.createproduct, clientRoutes.editproduct]);

export function AppNotifications() {
  const { pathname } = useLocation();
  const isProductEditorPage = PRODUCT_EDITOR_PATHS.has(pathname);

  return (
    <Notifications
      limit={8}
      position={isProductEditorPage ? 'bottom-left' : 'bottom-right'}
    />
  );
}
